import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./components/AuthContext";
import Login from "./components/Login";
import Logout from "./components/Logout";
import Dashboard from "./components/Dashboard";
import Categories from "./components/Categories";
import Subcategories from "./components/Subcategories";
import Products from "./components/Products";
import Attributes from "./components/Attributes";

// ProtectedRoute Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  return token ? children : <Navigate to="/" />;
};

function App() {
  return (
    <AuthProvider>
    <Router>
      <div className="App">
        <Routes>
          {/* Public Route */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          {/* Protected Route */}
          <Route path="/logout" element={<ProtectedRoute><Logout /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}/>
          <Route path="/categories" element={<ProtectedRoute><Categories /></ProtectedRoute>}/>
          <Route path="/Subcategories" element={<ProtectedRoute><Subcategories /></ProtectedRoute>}/>      
          <Route path="/Products" element={<ProtectedRoute><Products /></ProtectedRoute>}/> 
          <Route path="/Attributes" element={<ProtectedRoute><Attributes /></ProtectedRoute>}/>      
        </Routes>
      </div>
    </Router>
    </AuthProvider>
  );
}

export default App;